<template>
  <div>
    <h4 class="h4 m-t-0 m-b-2">Work Area</h4>
    <work-area v-if="locations.length" :locations="locations"/>
    <div v-else>No Work Area</div>
  </div>
</template>

<script>
import { geocode } from '@homeservices/api-kit/search';
import WorkArea from '@/components/WorkArea';

export default {
  name: 'work-area-section',
  components: {
    WorkArea,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      locations: [],
    };
  },
  async mounted () {
    try {
      const { data } = await geocode(this.profile.zipcodes.join(','), 'US', this.profile.zipcodes.length);

      this.locations = data.results.map((location) => {
        return {
          latlng: {
            lat: location.geo_point.center_latitude,
            lng: location.geo_point.center_longitude,
          },
        };
      });
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  },
};
</script>
